<template lang="pug">
control(:class="'checks'")
  label(v-if="checks.label")(v-html="checks.label")
  div
    field(
      v-for="(check, i) in checks.checks"
      :class="{ invalid: !checks.meta.valid && checks.meta.touched }")
      input(
        @blur="checks.blur"
        v-model="checks.model",
        :name="checks.name",
        :type="checks.type",
        :value="check.value",
        :id="check.id")
      label(:for="check.id")
        span(v-html="check.label")
      error(v-if="!checks.meta.valid && checks.meta.touched") {{ checks.errorMessage }}
</template>

<script>
import { useStore } from 'vuex';
import { reactive, computed } from 'vue';
import { useField } from 'vee-validate';
import * as yup from 'yup';

export default {
  name: 'Checkbox',
  props: {
    field: Object,
  },
  setup(p) {
    const store = useStore();
    const checks = reactive(initChecks());

    return { checks };

    function initChecks() {

        let labelHtml = p.field.label;
        if (labelHtml && p.field.required !== false ) labelHtml = `<b>${labelHtml}</b>`;
        
        const name = p.field.id;
        const label = labelHtml ? `${labelHtml}${p.field.required !== false ? " <span class='required'>*</span>" : ""}` : null;
        const type = 'checkbox';
        const len = p.field.values.length;
        let rules = '';

        if (p.field.required !== false) {
            if (len > 1) rules = yup.array().min(1).required();
            else rules = yup.boolean().oneOf([true], 'This filed is required.');
        }

        const checks = p.field.values.map(check => {

            let labelHtml2 = check[1];
            if (p.field.required !== false ) labelHtml2 = `<b>${labelHtml2}</b>`;

            const id = `${name}-${check[0]}`;
            const label = `${labelHtml2}${p.field.required !== false ? " <span class='required'>*</span>" : ""}`;
            const value = check[0];

            return reactive({ id, label, value });
        });

      const { value, errorMessage, meta, handleBlur, validate } = useField(
        name,
        rules,
        {
          validateOnInput: true,
        }
      );

      const model = computed({
        get: () =>
          Object.prototype.hasOwnProperty.call(store.getters.model, name)
            ? store.getters.model[name]
            : len > 1
            ? []
            : !p.field.values[0][0],
        set: v => {
          value.value = v;
          store.commit('updateModel', { id: name, value: v });
        },
      });

      if (len === 1 && !model.value) {
        model.value = !p.field.values[0][0];
      }

      const blur = async () => {
        store.commit('pushLastFieldToDataLayer', p.field.id);
        await validate();
        handleBlur();
      };
      return { name, label, type, checks, model, meta, blur, errorMessage };
    }
  },
};
</script>

<style lang="scss" scoped>
div {
  display: flex;
  flex-direction: column;
}
</style>
